import { BaasicDragAndDropItemTemplate } from 'themes/components';
import React from 'react';
import PropTypes from 'prop-types';

function BaasicDragAndDropItem(props) {
	return <BaasicDragAndDropItemTemplate {...props} />;
}

BaasicDragAndDropItem.propTypes = {
	item: PropTypes.object,
	currentDropBox: PropTypes.object,
	ItemComponent: PropTypes.elementType,
	dragAndDropField: PropTypes.string,
};

export default BaasicDragAndDropItem;



// WEBPACK FOOTER //
// ./src/core/components/BaasicDragAndDropItem.js